import { ShieldCheck } from "lucide-react";
import { Field } from "./Field";

export const StepBanking = ({ form, update }) => (
  <div className="space-y-6">
    <div
      className="flex items-start gap-3 rounded-xl border border-amber-400/20 bg-amber-400/5 px-4 py-3"
      data-testid="banking-confidential-notice"
    >
      <ShieldCheck size={18} className="text-amber-300 mt-0.5 shrink-0" />
      <p className="text-xs text-slate-300 leading-relaxed">
        <span className="font-semibold text-amber-300">Confidential.</span> Used for royalty payouts and client
        disbursements only. Stored securely and visible only to Xyion HQ.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <Field
        label="Account Holder Name"
        testid="input-account-holder"
        placeholder="Name on the account"
        value={form.banking.accountHolder}
        onChange={(e) => update("banking.accountHolder", e.target.value)}
      />
      <Field
        label="Bank Name"
        testid="input-bank-name"
        placeholder="e.g. Chase"
        value={form.banking.bankName}
        onChange={(e) => update("banking.bankName", e.target.value)}
      />
      <Field
        label="Account Type"
        testid="input-account-type"
        placeholder="Checking / Savings"
        value={form.banking.accountType}
        onChange={(e) => update("banking.accountType", e.target.value)}
      />
      <Field
        label="Routing Number"
        testid="input-routing-number"
        placeholder="9 digits"
        inputMode="numeric"
        value={form.banking.routingNumber}
        onChange={(e) => update("banking.routingNumber", e.target.value)}
      />
      <Field
        label="Account Number"
        testid="input-account-number"
        placeholder="Account number"
        inputMode="numeric"
        className="md:col-span-2"
        value={form.banking.accountNumber}
        onChange={(e) => update("banking.accountNumber", e.target.value)}
        hint="Stored securely. Visible to Xyion HQ only."
      />
    </div>
  </div>
);
